export default "__VITE_ASSET__1F6kHBq1__"